import {$authHost} from "./index";

export const createOrder = async (orderData) => {
    console.log('🚀 [ORDER API] Начинаем создание заказа с данными:', {
        discount_percent: orderData.discount_percent,
        discount_amount: orderData.discount_amount,
        total: orderData.total,
        total_with_discount: orderData.total_with_discount,
        items_count: orderData.items?.length
    });

    console.log('[ORDER API] discount_percent перед отправкой:', orderData.discount_percent, typeof orderData.discount_percent);
    const items = orderData.items || [];
    
    const payload = {
        ...orderData,
        items,
        discount_percent: orderData.discount_percent,
        discount_amount: orderData.discount_amount,
        total: orderData.total,
        total_with_discount: orderData.total_with_discount
    };

    console.log('📤 [ORDER API] Отправляем payload на сервер:', {
        discount_percent: payload.discount_percent,
        discount_amount: payload.discount_amount,
        total: payload.total,
        total_with_discount: payload.total_with_discount
    });

    const response = await $authHost.post('/api/order', payload);
    
    console.log('📥 [ORDER API] Ответ от сервера:', {
        order_id: response.data?.id,
        discount_percent: response.data?.discount_percent,
        discount_amount: response.data?.discount_amount,
        total: response.data?.total,
        total_with_discount: response.data?.total_with_discount
    });

    console.log('[ORDER API] discount_percent после ответа:', response.data?.discount_percent, typeof response.data?.discount_percent);
    // Приводим discount_percent к числу для одного заказа
    if (response.data && typeof response.data.discount_percent !== 'undefined') {
        response.data.discount_percent = Number(response.data.discount_percent) || 0;
    }
    return response.data;
}

export const fetchOrders = async () => {
    const {data} = await $authHost.get('api/order');
    // Приводим discount_percent к числу для всех заказов
    if (Array.isArray(data)) {
        data.forEach(order => {
            order.discount_percent = Number(order.discount_percent) || 0;
        });
    }
    return data;
}

export const removeOrderItem = async (orderItemId) => {
    const {data} = await $authHost.delete('api/order/item/' + orderItemId);
    return data;
};

export const completeOrder = async (orderId, paymentType = 'cash') => {
    const {data} = await $authHost.post('api/order/complete/' + orderId, { paymentType });
    return data;
};

export const fetchUserOrders = async () => {
    const {data} = await $authHost.get('api/order/user');
    // Приводим discount_percent к числу для всех заказов
    if (Array.isArray(data)) {
        data.forEach(order => {
            order.discount_percent = Number(order.discount_percent) || 0;
        });
    }
    return data;
};

export const getSalesHistoryDay = async (date) => {
    const {data} = await $authHost.get('api/order/sales/day', { params: { date } });
    return data;
};

export const getSalesHistoryMonth = async (year, month) => {
    const {data} = await $authHost.get('api/order/sales/month', { params: { year, month } });
    return data;
};

export const updateOrderStatus = async (orderId, status) => {
    const {data} = await $authHost.patch(`api/order/${orderId}/status`, { status });
    return data;
};

export const createSale = async (products, paymentType = 'cash', userEmail = '') => {
    const {data} = await $authHost.post('api/order/sale', {products, paymentType, userEmail});
    return data;
};

export const cancelOrder = async (orderId) => {
    const {data} = await $authHost.delete('api/order/' + orderId);
    return data;
};

export const fetchOrder = async (orderId) => {
    const {data} = await $authHost.get('api/order/' + orderId);
    if (data && typeof data.discount_percent !== 'undefined') {
        data.discount_percent = Number(data.discount_percent) || 0;
    }
    return data;
} 